const vi = {
  menu: {
    about: {
      title: "GIỚI THIỆU",
    },
    products: {
      title: "SẢN PHẨM",
      tea: "Trà",
      coffee: "Cà phê",
      agricultural: "Nông sản",
      drink: "Nước giải khát",
      oil: "Dầu ăn",
    },
    promotion: {
      title: "Ưu đãi",
    },
    news: {
      title: "TIN TỨC",
      newsTea: "Tin tức trà",
      newsCoffee: "Tin tức cà phê",
      newsAgri: "Tin tức nông sản",
    },
    contact: {
      title: "LIÊN HỆ",
    },
    recruitment: {
      title: "Tuyển dụng",
    },
    noidia: {
      title: "NỘI ĐỊA",
    },
    xuatkhau: {
      title: "XUẤT KHẨU",
    },
    muahang: {
      title: "MUA HÀNG",
    },
    search: {
      title: "Tìm kiếm",
    },
    profile: {
      title: "Hồ sơ",
    },
    language: {
      title: "Ngôn ngữ",
    },
  },
  miniCart: {
    titleA: "Bạn có ",
    titleB: " sản phẩm trong giỏ",
    statusStock: "Đang có hàng",
    labelTotal: "Tổng ước tính",
    btnCart: "Giỏ hàng",
    btnPay: "Thanh toán",
  },
  homeAbout: {
    product: "Sản phẩm chính",
    seeMore: "Giới thiệu về Việt Thiên",
  },
  profile: {
    manager: {
      home: "Trang chủ",
      title: "Quản lý tài khoản",
      info: "Thông tin tài khoản",
      info_dcr: "Quản lý thông tin tài khoản cá nhân của bạn",
      address: "Sổ địa chỉ",
      address_dcr: "Quản lý địa chỉ giao hàng, thanh toán của bạn",
      purchase: "Đơn hàng đã mua",
      purchase_dcr: "Quản lý các đơn hàng mà bạn đã mua hoặc trả lại",
      liked: "Sản phẩm yêu thích",
      liked_dcr: "Quản lý danh sách các sản phẩm yêu thích",
      adjust: "Tuỳ chọn",
      logout: "Đăng xuất",
      register: "Đăng ký",
      login: "Đăng nhập",
    },
    layout: {
      home: "Trang chủ",
      title: "Quản lý tài khoản",
      info: "Thông tin tài khoản",
      address: "Sổ địa chỉ",
      purchase: "Đơn hàng đã mua",
      liked: "Sản phẩm yêu thích",
    },
    info: {
      info: "Thông tin tài khoản",
      account: "Tên đăng nhập",
      name: "Họ và tên",
      date: "Ngày tháng năm sinh",
      sex: "Giới tính",
      male: "Nam",
      female: "Nữ",
      pass: "Mật khẩu",
      changePass: "Đổi mật khẩu",
      confirm: "Xác nhận thay đổi thông tin",
      currPass: "Mật khẩu hiện tại",
      newPass: "Mật khẩu mới",
      conPass: "Xác nhận mật khẩu mới",
      valPass: "Tối thiểu 6 ký tự bao gồm chữ hoa, chữ thường và số",
      noti: "Cập nhật thành công",
      notiFail: "Cập nhật không thành công",
      valName: "Vui lòng nhập đầy đủ họ và tên",
    },
    address: {
      title: "Sổ địa chỉ",
      default: " - Địa chỉ mặc định",
      addAddress: "Thêm địa chỉ",
      creatAddress: "Tạo mới sổ địa chỉ",
      changeAddress: "Chỉnh sửa",
      deleteAddress: "Xoá",
      deleteNoti: "Đã xoá địa chỉ",
      province: "Tỉnh thành phố",
      district: "Quận, huyện",
      ward: "Phường xã",
      slProvince: "Chọn tỉnh thành phố",
      slDistrict: "Chọn quận, huyện",
      slWard: "Chọn phường xã",
      setDF: "Đặt làm địa chỉ mặc định",
      save: "Lưu địa chỉ",
      changeNoti: "Thông tin đang được cập nhật",
    },
    order: {
      order: "Quản lý đơn hàng",
      title: "Danh sách đơn hàng đã mua",
      date: "Ngày đặt hàng",
      datepredict: "Ngày giao hàng dự kiến",
      id: "Mã đơn hàng",
      product: "Sản phẩm",
      quantity: "Số lượng",
      total: "Tổng tiền",
      orderDetail: "Chi tiết đơn hàng",
      name: "Tên người nhận",
      phone: "Số điện thoại",
      address: "Địa chỉ người nhận",
      detail: "Chi tiết",
      unitPrice: "Đơn giá",
      price: "Thành tiền",
      temp: "Tạm tính",
      ship: "Phí giao hàng",
      freeship: "Tiền miễn phí vận chuyển",
      cancelOrder: "Huỷ đơn",
      cancelReason: "Lý do huỷ đơn",
      cancel_dcr: "Lý do huỷ đơn của bạn là: ",
      confirm: "Xác nhận",
      cancel: "Huỷ",
      pay: "Tiếp tục thanh toán",
      rebuy: "Đặt lại",
      cancelNoti_suc: "Đã huỷ đơn",
      cancelNoti_fail: "Huỷ đơn không thành công",
      cancelNoti_val: "Vui lòng nhập đủ kí tự( >5)",
      rebuyNoti_suc: "Thêm vào giỏ hàng thành công",
      rebuyNoti_val: "Yêu cầu đang được xử lý",
    },
    liked: {
      title: "Sản phẩm yêu thích",
      noliked: "Bạn chưa có sản phẩm yêu thích",
    },
  },
  menuAuth: {
    account: "Tài khoản",
    profile: "Hồ sơ",
    address: "Sổ địa chỉ",
    order: "Đơn hàng",
    liked: "Sản phẩm yêu thích",
    option: "Tùy chọn",
    logout: "Đăng xuất",
  },
  homeLiked: {
    title: "Các loại trà được yêu thích",
  },
  homePromotion: {
    title: "Ưu đãi",
  },
  homeNews: {
    title: "TIN TỨC",
  },
  subscribe: {
    title: "Đăng ký để nhận thông tin từ Việt Thiên",
    placeholder: "Nhập email của bạn",
    button: "Đăng ký",
    alertSuccess: "Đăng ký nhận tin tức thành công",
    alertFailed: "Đăng ký nhận tin tức không thành công",
  },
  footer: {
    addressLabel: "Địa chỉ liên hệ",
    customerPolicy: "CHÍNH SÁCH KHÁCH HÀNG",
    contactInfo: "THÔNG TIN LIÊN HỆ",
    factory: "NHÀ MÁY",
    followUs: "LIÊN HỆ VỚI CHÚNG TÔI",
    contactWith: "KẾT NỐI VỚI VIỆT THIÊN",
    payments: "Phương thức thanh toán",
    cod: "Thanh toán trực tiếp",
    bankTransfer: "Chuyển khoản",
    wallet: "Ví điện tử",
    info1: "GIấy CNĐKKD: 0305693542 - Ngày cấp 22/02/2008",
    info2: "Cơ quan cấp: Sở Kế Hoạch và Đầu Tư TP HCM.",
  },
  contact: {
    content:
      "Nếu bạn có bất kỳ thắc mắc hay mong muốn hợp tác, vui lòng để lại thông tin liên hệ chúng tôi sẽ hỗ trợ sớm nhất.",
    taxCodeLabel: "Mã số thuế",
    email: "Email",
    address: "Văn phòng",
    toast: {
      success: "Gửi thông tin thành công",
      error: "Gửi thông tin không thành công",
    },

    form: {
      title: "Liên hệ với chúng tôi",
      fullName: "Họ và tên",
      email: "Email",
      phone: "Số điện thoại",
      address: "Địa chỉ",
      content: "Ý kiến",
      button: "Gửi thông tin",
      loading: "Đang gửi...",
    },
    placeholder: {
      fullName: "Họ và tên",
      email: "Địa chỉ email",
      phone: "Số điện thoại liên hệ",
      content: "Nhập nội dung ở đây...",
      address: "Địa chỉ liên hệ",
    },
    map: {
      title: "Danh sách nhà máy Việt Thiên",
    },
  },
  collections: {
    filterCategory: "Danh mục",
    filterPrice: "Giá",
    remove: "Xóa",
    from: "Từ",
    to: "Đến",
    establish: "Thiết lập",
    searchResult: "Kết quả tìm kiếm cho: ",
    notfound: "Không tìm thấy sản phẩm",
    notFoundPromotion: "Hiện chưa có sản phẩm khuyến mãi",
    filter: "Lọc",
    reset: "Đặt lại",
    apply: "Áp dụng",
    sort: "SẮP XẾP THEO: ",
  },
  login: {
    seoTitle: "Đăng nhập - Việt Thiên",
    title: "Đăng nhập tài khoản",
    username: "Email hoặc số điện thoại",
    password: "Mật khẩu",
    forgotPass: "Quên mật khẩu?",
    submit: "ĐẶNG NHẬP",
    swap: "Bạn chưa phải thành viên, vui lòng ",
    or: "HOẶC",
    loginFB: "Đăng nhập bằng Facebook",
    signup: "Đăng ký",
    placeholder: {
      username: "Nhập email hoặc số điện thoại của bạn",
      password: "Tối thiệu 6 ký tự bao gồm chữ hoa, chữ thường và số",
    },
    validate: {
      blank: "Email hoặc số điện thoại không được để trống",
      blankPassword: "Mật khẩu không được để trống",
    },
  },
  forgotPassword: {
    title: "Khôi phục mật khẩu",
    username:
      "Email hoặc số điện thoại (chúng tôi sẽ gửi cho bạn mã OTP để đặt lại mật khẩu)",
    submit: "Gửi và xác nhận",
    placeholder: {
      username: "Nhập email hoặc số điện thoại của bạn",
    },
    validate: {
      blank: "Tài khoản không được để trống",
      send: "Gửi mã xác nhận không thành công",
    },
  },
  resetPassword: {
    newPassword: "Mật khẩu mới",
    reNewPassword: "Nhập lại mật khẩu mới",
    submit: "Đổi mật khẩu",
    placeholder: "Tối thiểu 6 ký tự bao gồm chữ hoa, chữ thường và số",
  },
  otpFrom: {
    title: "Mã xác thực",
    submit: "Xác nhận",
    resend: "Gửi lại",
    placeholder: "Nhập mã của bạn",
  },
  register: {
    seoTitle: "Đăng ký - Việt Thiên",
    title: "Đăng ký tài khoản",
    phoneNumber: "Số điện Thoại",
    emailAddress: "Email",
    userName: "Email hoặc số điện thoại",
    fullName: "Họ và tên",
    password: "Mật khẩu",
    rePassword: "Nhập lại mật khẩu",
    role: "Tôi đã đọc và chấp nhận ",
    policy: "điều khoản",
    submit: "Đăng ký",
    swap: "Bạn đã là thành viên, vui lòng ",
    login: "Đăng nhập",
    linkPolicy: "/chinh-sach/chinh-sach-bao-mat",
    instructor: "Mã giới thiệu",
    confirm: "Tôi đã đọc, hiểu và chấp nhận",
    theTerms: "điều khoản",
    done: "Hoàn tất",
    placeholder: {
      phoneNumber: "Nhập số điện Thoại",
      emailAddress: "Nhập Email",
      userName: "Nhập email hoặc số điện thoại của bạn",
      fullName: "Nhập họ và tên",
      password1: "Nhập mật khẩu",
      password: "Tối thiểu 6 ký tự bao gồm chữ hoa, chữ thường và số",
      rePassword: "Nhập xác nhận lại mật khẩu",
      instructor: "Nhập mã giới thiệu",
    },
    alert: {
      sendOtpSuccess: "Mã xác thực đã gửi đến ",
      sendOtpFailed: "Gửi lại mã xác thực không thành công",
      success: "Tạo tài khoản thành công! Đăng nhập để mua sắm ngay nào",
    },
    validate: {
      email: "Email hoặc số điện thoại không hợp lệ",
      blankPassword: "Mật khẩu không được để trống",
      password:
        "Mật khẩu có ít nhất 6 ký tự và ít nhất 1 chữ hoa, 1 chữ thường, 1 chữ số",
      password1: "Nhập lại mật khẩu không trùng khớp",
    },
  },
  cart: {
    cartInfo: "Thông tin đơn hàng",
    temp: "Thành tiền",
    ship: "Phí giao hàng (tạm tính)",
    freeship: "Miễn phí giao hàng",
    total: "Tổng ước tính",
    pay: "Đặt hàng",
    choose: "Chọn ngay",
    avail: "Đang có hàng",
    typeShip: "Chọn đơn vị vận chuyển",
    accept: "Chấp nhận",
    voucher: "Mã giảm giá",
    chooseVoucher: "Nhập mã giảm giá của bạn",
  },
  noti: {
    title: "Thông báo",
  },
  product: {
    title: "TẤT CẢ SẢN PHẨM",
    subTitle:
      "Khám phá trọn vẹn danh mục sản phẩm đa dạng và chất lượng của Việt Thiên",
  },
};

export default vi;
